import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import WhyChooseUs from './components/WhyChooseUs';
import FeedbackForm from './components/FeedbackForm';
import Footer from './components/Footer';
import { ResumeBuilder } from './components/ResumeBuilder';

export default function App() {
  const [showBuilder, setShowBuilder] = useState(false);

  if (showBuilder) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="pt-20">
          <ResumeBuilder />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero onStart={() => setShowBuilder(true)} />
      <Stats />
      <Features />
      <HowItWorks />
      <WhyChooseUs />
      <FeedbackForm />
      <Footer />
    </div>
  );
}